"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _services = require("../../../../services");
var _r10SourceLibrary = require("r10-source-library");
var _useDynamicPageContent = _interopRequireDefault(require("../../../../hooks/dynamic/useDynamicPageContent"));
var _constants = require("../../../../utils/constants");
var _useUpsell2 = _interopRequireDefault(require("../../../../hooks/upsell/useUpsell"));
var _upsellUtils = require("../../../../utils/upsellUtils");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: center;\n  align-items: center;\n"])), function (props) {
  return props.isSmall ? 'column' : 'row';
});
var ConnectivityPlan = function ConnectivityPlan() {
  var breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  var _useDynamicPageConten = (0, _useDynamicPageContent.default)(),
    setDynamicContentPage = _useDynamicPageConten.setDynamicContentPage;
  var _useUpsell = (0, _useUpsell2.default)(),
    connectivityPlan = _useUpsell.connectivityPlan,
    setConnectivityPlanIsSelected = _useUpsell.setConnectivityPlanIsSelected;
  var offering = connectivityPlan.offering,
    selected = connectivityPlan.selected;
  var _getPriceData = (0, _upsellUtils.getPriceData)(offering),
    value = _getPriceData.value;
  var handleCheckboxChange = function handleCheckboxChange() {
    setConnectivityPlanIsSelected(!selected);
  };
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 9
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    text: _services.locale.localeString('AccessoryModal.ConnectivityPlanTitle'),
    appearance: "secondary",
    justify: "center"
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: true
  }, /*#__PURE__*/_react.default.createElement(StyledWrapper, {
    isSmall: breakpoints.sm
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12,
    colMd: 7
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    align: "center",
    noGutters: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 8
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.CheckboxList, {
    fieldWrapper: {
      label: ''
    },
    checkboxes: {
      groupName: 'connectivity-plan',
      id: 'connectivity-plan',
      onChange: handleCheckboxChange,
      items: [{
        label: /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
          size: 2,
          weight: 2
        }, _services.locale.localeString('AccessoryModal.ConnectivityPlanDescription')),
        value: 'connectivity-plan',
        checked: selected
      }]
    }
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 3
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      left: 3
    }
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 6,
    colMd: 5
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "end"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      right: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 3,
    appearance: "secondary"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 1
  }, /*#__PURE__*/_react.default.createElement("del", null, _services.locale.formatPrice(value)), "\xA0"), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 3
  }, _services.locale.formatPrice(value)), "\xA0", /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 2
  }, _services.locale.localeString('AccessoryModal.Monthly'))))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    justify: 'center'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Link, {
    id: "test",
    appearance: "primary",
    text: _services.locale.localeString('AccessoryModal.ConnectivityPlanButtonText'),
    fullSize: true,
    size: 1,
    onClick: function onClick() {
      return setDynamicContentPage(_constants.DYNAMIC_PAGES.UPSELL_CONNECTIVITY_PLAN);
    },
    showUnderline: true
  })))));
};
var _default = ConnectivityPlan;
exports.default = _default;